









// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditBasePersonne from '@/components/personne/edit/EditBasePersonne.vue';
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { AloPersonne, getDefaultAloPersonne } from '@/models/alo/AloPersonne';
import * as rules from '@/utils/validationRules'
import { ApiUserRole } from '@/enum/ApiUserRole';

@Component({
  name: 'EditPortail',
  components:{EditBasePersonne}
})
export default class EditPortail extends Vue {
  
  private personne = getDefaultAloPersonne()
  
  get isCentralWeb() {return this.$store.myGetters.isCentralWeb}
  
  get ApiUserRoles() {
    const roles = Object.keys(ApiUserRole)
    if(!this.isCentralWeb) roles.splice(0,1)
    return roles 
  }
  

  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  edit(item:AloPersonne) {    
    this.personne = (this.$refs.baseEdit as EditBasePersonne).edit(item)
  }  
  
}
